import React from "react";
import { HiBolt } from "react-icons/hi2";
import { MdOutlineDesignServices, MdSecurity } from "react-icons/md";
import { FaCloud, FaMobileAlt, FaRocket } from "react-icons/fa";

const AndroidFeaturesSection = () => {

  const features = [
    {
      icon: <HiBolt />,
      title: "Ultra Fast Performance",
      desc: "Optimized Android apps with blazing speed, smooth scrolling and instant interactions.",
    },
    {
      icon: <MdOutlineDesignServices />,
      title: "Premium UI/UX",
      desc: "Modern Android interfaces designed for better engagement and user retention.",
    },
    {
      icon: <FaCloud />,
      title: "Cloud Integration",
      desc: "Secure Firebase, AWS & scalable cloud architecture for powerful mobile apps.",
    },
    {
      icon: <MdSecurity />,
      title: "Advanced Security",
      desc: "Enterprise-grade Android app security with encrypted user data protection.",
    },
    {
      icon: <FaMobileAlt />,
      title: "Multi Device Support",
      desc: "Responsive Android apps working seamlessly across phones, tablets & foldables.",
    },
    {
      icon: <FaRocket />,
      title: "Play Store Ready",
      desc: "Complete Play Store deployment with ASO optimization & launch support.",
    },
  ];

  return (
    <>
      <section className="android-features-section">

        {/* Blur Background */}
        <div className="feature-blur blur-one"></div>
        <div className="feature-blur blur-two"></div>

        <div className="features-container">

          {/* Heading */}
          <div className="features-heading">

            <span className="feature-badge">
              ANDROID APP FEATURES
            </span>

            <h2>
              Powerful Features For<br />
              <span> Modern Android Apps</span>
            </h2>

            <p>
              We create Android applications packed with premium
              features, smooth performance and scalable technology.
            </p>

          </div>

          {/* Grid */}
          <div className="features-grid">

            {features.map((item, index) => (
              <div
                className="feature-card"
                key={index}
                style={{
                  animationDelay: `${index * 0.15}s`,
                }}
              >

                <div className="feature-glow"></div>

                <div className="feature-icon">
                  {item.icon}
                </div>

                <h3>{item.title}</h3>

                <p>{item.desc}</p>

                <div className="feature-line"></div>

              </div>
            ))}

          </div>

        </div>

        <style>{`
.feature-icon{
    width:72px;
    height:72px;

    display:flex;
    align-items:center;
    justify-content:center;



    border-radius:22px;

    background:linear-gradient(
        135deg,
        #E8212A 0%,
        #ff646b 100%
    );

    color:#fff;
    font-size:32px;

    box-shadow:
        0 15px 35px rgba(232,33,42,.25);

    transition:all .4s ease;
}

.feature-card:hover .feature-icon{
    transform:
        translateY(-8px)
        rotate(-6deg)
        scale(1.08);

    box-shadow:
        0 25px 60px rgba(232,33,42,.35);
}
        .android-features-section{
          position:relative;
          overflow:hidden;
          padding:130px 24px;
          background:linear-gradient(180deg,#fff,#fff7f7);
          font-family:'Plus Jakarta Sans',sans-serif;
        }

        .features-container{
          max-width:1250px;
          margin:auto;
          position:relative;
          z-index:2;
        }

        /* Heading */
        .features-heading{
          text-align:center;
          margin-bottom:90px;
        }

        .feature-badge{
          display:inline-block;
          padding:10px 18px;
          border-radius:100px;
          background:rgba(232,33,42,0.08);
          border:1px solid rgba(232,33,42,0.15);
          color:#E8212A;
          font-size:12px;
          font-weight:700;
          letter-spacing:1px;
          margin-bottom:24px;
          animation:fadeUp 1s ease;
        }

        .features-heading h2{
        font-size: 58px;
    line-height: 1.1;
    font-family: "Syne", sans-serif;
    color: #111;
    margin-bottom: 20px;
    letter-spacing: -2px;
    text-align: center;
          animation:fadeUp 1s ease;
        }

        .features-heading h2 span{
          color:#E8212A;
        }

        .features-heading p{
          max-width:760px;
          margin:auto;
          color:#666;
          font-size:18px;
          line-height:1.9;
          animation:fadeUp 1.1s ease;
              text-align: center;
        }

        /* Grid */
        .features-grid{
          display:grid;
          grid-template-columns:repeat(3,1fr);
          gap:30px;
        }

        .feature-card{
          position:relative;
          background:#fff;
          border-radius:34px;
          padding:38px;
          overflow:hidden;
          border:1px solid #f1f1f1;
          transition:0.5s;
          animation:fadeCard 1s ease both;
          box-shadow:0 15px 40px rgba(0,0,0,0.04);
        }

        .feature-card:hover{
          transform:translateY(-14px);
          box-shadow:0 40px 90px rgba(232,33,42,0.14);
          border-color:#ffd5d8;
        }

        .feature-glow{
          position:absolute;
          inset:0;
          background:linear-gradient(135deg,rgba(232,33,42,0.08),transparent);
          opacity:0;
          transition:0.5s;
        }

        .feature-card:hover .feature-glow{
          opacity:1;
        }

        .feature-icon{
           width: 60px;
    height: 60px;
          border-radius:28px;
          background:linear-gradient(135deg,#E8212A,#ff4d55);
          display:flex;
          align-items:center;
          justify-content:center;
          font-size:25px;
          color:#fff;
          margin-bottom:30px;
          position:relative;
          z-index:2;
          box-shadow:0 20px 40px rgba(232,33,42,0.2);
          animation:floatIcon 4s ease-in-out infinite;
        }

        .feature-card h3{
          font-size:28px;
          color:#111;
          margin-bottom:16px;
          font-family:'Syne',sans-serif;
          position:relative;
          z-index:2;
          line-height:1.2;
        }

        .feature-card p{
          color:#666;
          line-height:1.9;
          font-size:15px;
          position:relative;
          z-index:2;
        }

        .feature-line{
          width:0%;
          height:4px;
          border-radius:20px;
          margin-top:28px;
          background:linear-gradient(90deg,#E8212A,#ff4d55);
          transition:0.6s;
          position:relative;
          z-index:2;
        }

        .feature-card:hover .feature-line{
          width:100%;
        }

        /* Blur */
        .feature-blur{
          position:absolute;
          border-radius:50%;
          filter:blur(100px);
          z-index:1;
        }

        .blur-one{
          width:320px;
          height:320px;
          background:rgba(232,33,42,0.12);
          top:-100px;
          left:-100px;
        }

        .blur-two{
          width:340px;
          height:340px;
          background:rgba(255,77,85,0.14);
          right:-120px;
          bottom:-120px;
        }

        /* Animations */
        @keyframes fadeUp{
          from{
            opacity:0;
            transform:translateY(50px);
          }
          to{
            opacity:1;
            transform:translateY(0);
          }
        }

        @keyframes fadeCard{
          from{
            opacity:0;
            transform:translateY(80px);
          }
          to{
            opacity:1;
            transform:translateY(0);
          }
        }

        @keyframes floatIcon{
          0%{
            transform:translateY(0);
          }
          50%{
            transform:translateY(-10px);
          }
          100%{
            transform:translateY(0);
          }
        }

        /* Responsive */
        @media(max-width:1100px){

          .features-grid{
            grid-template-columns:repeat(2,1fr);
          }

        }

        @media(max-width:768px){

          .android-features-section{
            padding:90px 18px;
          }

          .features-heading h2{
            font-size:42px;
            letter-spacing:-2px;
          }

          .features-grid{
            grid-template-columns:1fr;
          }

          .feature-card{
            padding:30px;
          }

          .feature-icon{
            width:72px;
            height:72px;
            font-size:32px;
            margin: auto;
          }

          .feature-card h3{
            font-size:24px;
                    text-align: center;
          }

.feature-card p{
text-align: center;
}

        }

      `}</style>
      </section>
    </>
  );
};

export default AndroidFeaturesSection;